// import cls from 'classnames'
// import { useState } from 'react'
import styles from './PeriodReason.module.less'
import MarkdownRenderer from '@/components/MarkdownRenderer/MarkdownRenderer'
import AIcon from '@/components/A/AIcon/AIcon'
import { useTranslation } from 'react-i18next'
// import { commonUtils } from '@/helpers/commonUtils'
// import { genRangeDesc } from '../../StoryboardAnalysis'
import MiddleText from '@/components/MiddleText/MiddleText'
interface PeriodReasonProps {
  reason: {
    performance?: string
    advantage?: string
    disadvantage?: string
    suggestions?: string
  }
  hasTranslated: boolean
  animation: boolean
}

function PeriodReason(p: PeriodReasonProps) {
  const { t } = useTranslation()
  // const [reasonIndex,] = useState<number>(0)
  return p.reason ? (
    <div className={styles.periodReason}>
      {/* {periods.length > 1 && (
        <div className={styles.tabs}>
          {periods.map((item, index) => {
            return (
              <div
                key={index}
                className={cls(styles.tab, { [styles.active]: reasonIndex === index })}
                onClick={() => setReasonIndex(index)}
              >
                {genRangeDesc(item)}
              </div>
            )
          })}
        </div>
      )}
      {periods.length === 1 && <div className={styles.singleTab}>{genRangeDesc(periods[0])}</div>}
 */}
      <div className={styles.reason}>
        {/* {p.reason.performance && (
          <div className={styles.performance}>
            <div className={styles.performanceTitle}>
              <img
                src={commonUtils.getImagePath('projectDetailPage/range-title-light.png')}
                alt=''
              />
              <MiddleText text={t('dashboard.projectDetailPage.storyboardView.summary')} />
            </div>
            <MarkdownRenderer
              loading={!p.hasTranslated}
              markdownText={p.reason.performance}
              needAnimation={p.animation}
              components={{
                h3: ({ children }) => {
                  return <h3 className={styles.h3Title}>{children}</h3>
                },
              }}
            />
          </div>
        )} */}
        {p.reason.advantage && (
          <div className={styles.advantage}>
            <div className={styles.advantageTitle}>
              <span>{t('dashboard.projectDetailPage.storyboardView.advantages')}</span>
            </div>
            <MarkdownRenderer
              loading={!p.hasTranslated}
              markdownText={p.reason.advantage}
              needAnimation={p.animation}
              components={{
                h3: ({ children }) => {
                  return <h3 className={styles.h3Title}>{children}</h3>
                },
              }}
            />
          </div>
        )}
        {p.reason.disadvantage && (
          <div className={styles.disadvantage}>
            <div className={styles.disadvantageTitle}>
              <span>{t('dashboard.projectDetailPage.storyboardView.disadvantages')}</span>
            </div>
            <MarkdownRenderer
              loading={!p.hasTranslated}
              markdownText={p.reason.disadvantage}
              needAnimation={p.animation}
              components={{
                h3: ({ children }) => {
                  return <h3 className={styles.h3Title}>{children}</h3>
                },
              }}
            />
          </div>
        )}
        {p.reason.suggestions && (
          <div className={styles.suggestions}>
            <div className={styles.suggestionsTitle}>
              <AIcon width={28} type='icon-fill-global_suggestion' />
              <MiddleText text={t('dashboard.projectDetailPage.storyboardView.suggestions')} />
            </div>
            <MarkdownRenderer
              loading={!p.hasTranslated}
              markdownText={p.reason.suggestions}
              needAnimation={p.animation}
              components={{
                h3: ({ children }) => {
                  return <h3 className={styles.h3Title}>{children}</h3>
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  ) : null
}

export default PeriodReason
